  <!--
   功能名称:千里眼平台(技师)-会员管理(下拉筛选菜单)
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="DropdownMenu-wrap">
    <van-dropdown-menu active-color="#691BFF">
      <van-dropdown-item title="按卡余额 " ref="cardNum">
        <cardNum :card_num="param.card_num" @onConfirm="onConfirm" @onReset="reset"/>
      </van-dropdown-item>
      <van-dropdown-item title="按间隔时长 " ref="intervalDay">
        <intervalDay :interval_day="param.interval_day" @onConfirm="onConfirm" @onReset="reset"/>
      </van-dropdown-item>
      <van-dropdown-item title="按生日 " ref="beforeBirthday">
        <beforeBirthday :before_birthday="param.before_birthday" @onConfirm="onConfirm" @onReset="reset"/>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
</template>

<script>
export default {
  name:'DropdownMenu',
  props:{
    param:{
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {return {before_birthday:-1,card_num:0,interval_day:0,phone:''}}
    }
  },
  data() {
    return {

    };
  },
  components:{
    'cardNum':()=>import('./from/cardNum'),
    'intervalDay':()=>import('./from/intervalDay'),
    'beforeBirthday':()=>import('./from/beforeBirthday')
  },
  mounted() {
  },
  methods: {
    onConfirm(val) {
      switch(Object.keys(val)[0]){
        case 'card_num':
          this.$refs.cardNum.toggle();
          break;
        case 'interval_day':
          this.$refs.intervalDay.toggle();
          break;
        default:
          this.$refs.beforeBirthday.toggle();
      }
      this.$emit('updateParam',val)
    },
    reset(msg) {
      this.$emit('onReset',msg)
    }
  },
};
</script>

<style lang="scss" scoped>
  .DropdownMenu-wrap{
    border-top: 1px solid #EEEEEE;
    border-bottom:1px solid #EEEEEE;
    // 重写下拉菜单样式
    /deep/ .van-dropdown-menu{
      .van-dropdown-menu__title--down::after {
          margin-top:0;
      }
      .van-dropdown-menu__title{
        border: 1px solid #F5F5F5;
        border-radius: 31px;
        padding-left:24px;
        padding-right: 70px;
        background: #F5F5F5;
        font-size: 28px;
        font-weight: 500;
        line-height: 60px;
      }
      .van-dropdown-menu__title::after {
        margin-top: -10px;
          position: absolute;
          right: 34px;
          top: 50%;
          content: '';
          display: inline-block;
          width: 10px;
          height: 10px;
          border: 1px solid;
          border-color: transparent transparent #1C1C1C #1C1C1C;
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
      }
      .van-dropdown-menu__title--active{
        border-color:#691BFF;
      }
      .van-dropdown-menu__title--active::after {
           border-color: transparent transparent #691BFF #691BFF;
      }
    }
  }
</style>
